module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG9f92dd01ef288e7476c5f393580ecbc7.9f92dd01.png";